{
  "profileSettings": "Profile Settings",
  "profileUpdated": "Profile updated"
}
